import LinkDialogService from './link-dialog-service'

class DialogService {
	insList = []
	Vue

	constructor(Vue) {
		this.Vue = Vue
	}

	get $lv() {
		return this.Vue.prototype.$lv
	}

	get instance() {
		let ins;
		for (let i = 0; i < this.insList.length; i++) {
			const item = this.insList[i];
			if (!item.p_value) ins = item
		}
		if (!ins) {
			ins = this.$lv.newInstance(LinkDialogService)
		}
		this.insList.push(ins)
		return ins
	}

	show(message, option) {
		return this.instance.show(message, option)
	}

	error(message, option) {

		let msg, opt;
		if (this.$lv.$utils.typeOf(message) === 'object') {
			msg = message.message
			opt = message
		} else {
			msg = message
			opt = option || {}
		}

		const instance = this.instance;

		return instance.show(Object.assign({
			noHeader: true,
			noFooter: true,
			dialogClass: 'link-dialog-message-service',
		}, opt, {
			render(h) {
				return (
					<div class="link-dialog-message-service">
						<link-icon icon="link-icon-close-circle"/>
						<div>
							<div class="link-dialog-message-service-title">{opt.title || '系统异常'}</div>
							<div class="link-dialog-message-service-content">{msg}</div>

							<div class="link-dialog-message-service-button">
								{/*如果要去掉反馈按钮，在产品工程的processComponent中，设置判断name是不是DialogService，设置DialogService.showFeedback为false*/}
								{DialogService.showFeedback !== false && <link-button label="去反馈" onClick={() => this.$feedback.show()}/>}
								<link-button label="我知道了" onClick={() => instance.hide()}/>
							</div>
						</div>
					</div>
				)
			},
		}))
	}
}

export {
	DialogService,
}
